import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { GetSetOperations } from 'app/shared/common/helper/profile';
import { ActivatedRoute, Router } from '@angular/router';
import { ProfilehelperDD } from 'app/shared/common/helper/personaldetails-helper';
import { ToastBaseModel } from 'app/shared/common/toast-data-model';
import { ToastrService } from 'ngx-toastr';
import { GetOperations } from 'app/shared/common/helper/dropdown';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import { ActivityCenterService } from 'app/shared/common/helper/activity-center';
import { DateServiceService } from 'app/shared/common/helper/dateservice';
import { MatDatepicker } from '@angular/material';
import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
const moment = _rollupMoment || _moment;

@Component({
  selector: 'app-profile-detail',
  templateUrl: './profile-detail.component.html',
  styleUrls: ['./profile-detail.component.scss']
})

export class ProfileDetailComponent implements OnInit {

  PdForm: FormGroup;
  personalDetailsForm: FormGroup;
  formErrors: any;
  officialDetailsForm: FormGroup;
  userId = this.parseService.instance.User.current().id;
  officialEmail: any;
  username;
  profileValue: any;
  designation: any;
  gender: any;
  dob: any;
  martialStatus: any;
  about: any;
  organisation: any;
  location: any;
  department: any;
  reportingTo: any;
  doj: any;
  yearOfExperience: any;
  monthOfExperience: any;
  address: any;
  mobileNumber: any;
  personalEmail: any;
  objectId: '';
  userProfileId: any;
  reportingDate: any;
  panNumber: any;
  salaryAccountNumber: any;
  personalAccountNumber: any;
  firstname: String;
  lastname: String;
  skillSets = [];
  organisationLists = [];
  reportList = [];
  roleList = [];
  locationList = [];
  departmentList = [];
  reportingtoList = []
  profileId: any;
  empRole = '';
  startTimeList = [];
  noticePeriod: any;
  resignationForm: FormGroup;
  show: boolean = true;
  confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>
  profileValues: any;
  isActive: boolean;
  currentUser = this.parseService.instance.User.current();
  oldOfficialDetails: any;
  oldReporting: any;
  oldLocation: any;
  oldDepartment: any;
  oldRole: any;
  oldOrganisation: any;
  oldvalue: any;
  selectedDate: any;
  nonWorkingDays = [];
  workingDays: any;
  dedicatedBillable: any;
  fixedBillable: any;
  nonBillable: any;
  selectedUserId: any;
  currentDate = new Date();
  formDate = new FormControl(moment());
  selectedDepartment = '';
  tenantId: '';
  industryId: any;
  esslEmployeeCode: string = '';
  esslEmployeeId: string = '';

  constructor(
    private queryInterface: QueryInterface,
    private parseService: ParseService,
    private profileInterface: GetSetOperations,
    private route: ActivatedRoute,
    private _helper: ProfilehelperDD,
    private formBuilder: FormBuilder,
    private toastMessage: ToastBaseModel,
    private profileDropDown: GetOperations,
    private toastr: ToastrService,
    private router: Router,
    private storageConfiguration: StorageConfiguration,
    public dialog: MatDialog,
    private hardCodedValues: HardCodedValues,
    private activityCenterService: ActivityCenterService,
    private dateService: DateServiceService

  ) {
    this.reportingtoList = this._helper.reportingtoLists;
    this.firstname = this.parseService.instance.User.current().get('firstName');
    this.lastname = this.parseService.instance.User.current().get('lastName');
    this.industryId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.industryId);
  }

  ngOnInit() {
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.route.params.subscribe(async params => {
      this.objectId = params['id'];

      let user = this.parseService.instance.Object.extend('User');
      let query = new this.parseService.instance.Query(user);
      query.equalTo('profile', { __type: 'Pointer', className: 'Profile', objectId: this.objectId });
      query.limit(10000);
      let result = await query.find();
      if (result.length > 0) {
        this.selectedUserId = result[0].id;
        this.getResourceStatus('');
      }
    });

    if (this.objectId) {
      var user = new this.parseService.instance.Object('Profile');
      user.id = this.objectId;
      user.fetch().then(
        res => {
          this.firstname = res.get('firstName');
          this.lastname = res.get('lastName');
        });
    }

    this.officialDetailsForm = this.formBuilder.group({
      organisationId: ['', Validators.required],
      locationId: ['', Validators.required],
      departmentId: ['', Validators.required],
      roleId: ['', Validators.required],
      reporterId: ['', Validators.required],
      startTime: ['', Validators.required],
      seatNo: ['', Validators.required],
      doj: ['', Validators.required],
      officialEmail: ['', [Validators.required, Validators.email]],
      yearofExperiences: ['', Validators.required],
      months: ['', Validators.required],
      gitUserId: ['', Validators.required],
      reportingDate: ['', Validators.required],
      employeeId: [''],
      employeeCode: ['']
    });

    this.resignationForm = this.formBuilder.group({
      resignationAppliedDate: ['', Validators.required],
      noticePeriod: ['', Validators.required],
      resignationAcceptedDate: ['', Validators.required],
      releasedDate: ['', Validators.required]
    });

    this.getLocation();
    this.getRole();
    this.getOrganisation();
    this.getDepartment();
    this.getReportingTo();
    this.getPersonalDetails();
    this.getOfficialDetails();
    this.getDropDowns();
  }


  async getDropDowns() {
    let queryInstance = this.parseService.instance.Object.extend('DataSettings');
    let query = new this.parseService.instance.Query(queryInstance);
    let result = await query.find();
    var dropdownresults = result[0],
      profileDropDownValue = this.profileDropDown.getProfileDropDown(
        dropdownresults
      ),
      startTimeObj = this.startTimeList,
      startTimeList = profileDropDownValue.startTime;
    for (var i = 0; i < startTimeList.length; i++) {
      startTimeObj.push(startTimeList[i]);
    }
  }

  viewTimeSheet() {
    this.router.navigate(['timesheet-view', { id: this.objectId }]);
  }

  getPersonalDetails() {
    let condition = [{ condition: 'equalTo', field: 'objectId', value: this.objectId },
    ]
    this.queryInterface.executeQuery(this.parseService, 'Profile', condition).then(results => {
      this.loadResources(results);
    });
  }

  loadResources(results) {
    let i = 0;
    let result = results[0];
    if (result != undefined) {
      this.profileId = result.id;
      let officialInfo = result.get('officialInfo'),
        personalInfo = result.get('personalInfo');
      this.username = result.get('username');
      let skills = result.get('skillSet');
      skills.forEach(element => {
        this.skillSets.push(element.name);
      });
      var locationObject = result.get('location');
      this.location = locationObject ? locationObject.get('name') : '';
      var organisationObject = result.get('organisation');
      this.organisation = organisationObject ? organisationObject.get('name') : '';
      var departmentObject = result.get('department');
      this.department = departmentObject.get('name');
      var reportingObject = result.get('reportingTo');
      this.reportingTo = reportingObject.get('username');
      this.reportingDate = officialInfo.reportingDate ? officialInfo.reportingDate : '';
      this.officialEmail = officialInfo.officialEmail ? officialInfo.officialEmail : '';
      this.panNumber = officialInfo.panNumber ? officialInfo.panNumber : '';
      this.personalAccountNumber = officialInfo.personalAccountNumber ? officialInfo.personalAccountNumber : '';
      this.salaryAccountNumber = officialInfo.salaryAccountNumber ? officialInfo.salaryAccountNumber : '';
      this.doj = officialInfo.doj ? officialInfo.doj : '';
      this.yearOfExperience = officialInfo.experience ? officialInfo.experience.year : '';
      this.monthOfExperience = officialInfo.experience ? officialInfo.experience.month : '';
      this.gender = personalInfo.gender ? personalInfo.gender : '';
      this.dob = personalInfo.dob ? personalInfo.dob : '';
      this.martialStatus = personalInfo.martialStatus ? personalInfo.martialStatus : '';
      this.about = personalInfo.about ? personalInfo.about : '';
      this.address = personalInfo.permanentAddress ? personalInfo.permanentAddress : '';
      this.mobileNumber = personalInfo.mobileNo.number ? personalInfo.mobileNo.number : personalInfo.mobileNo ? personalInfo.mobileNo : '';
      this.personalEmail = personalInfo.personalEmail ? personalInfo.personalEmail : '';
      this.esslEmployeeCode = result.get('esslEmployeeCode') ? result.get('esslEmployeeCode') : '';
      this.esslEmployeeId = result.get('esslEmployeeId') ? result.get('esslEmployeeId') : '';
    }
  }

  async getOfficialDetails() {
    await this.queryInterface.executeQuery(this.parseService, 'Profile', [{ condition: 'equalTo', field: 'objectId', value: this.objectId }, { condition: 'equalTo', field: 'tenantId', value: this.tenantId }]).then(result => {
      var results = result[0];
      if (results != undefined) {
        let jsonText = JSON.stringify(results);
        let userProfile = JSON.parse(jsonText);
        this.profileValue = userProfile;

        this.oldReporting = this.profileValue.reportingTo.objectId;
        this.oldLocation = this.profileValue.location ? this.profileValue.location.objectId : '';
        this.oldDepartment = this.profileValue.department.objectId;
        this.oldRole = this.profileValue.role.objectId;
        this.oldOrganisation = this.profileValue.organisation ? this.profileValue.organisation.objectId : '';

        if (this.profileValue.officialInfo.experience == undefined) {
          this.profileValue.officialInfo.experience = { year: '', month: '' };
        }
        this.isActive = userProfile.isActive;
        this.officialDetailsForm.patchValue({
          locationId: this.profileValue.location == undefined ? '' : this.profileValue.location.objectId,
          organisationId: this.profileValue.organisation == undefined ? '' : this.profileValue.organisation.objectId,
          departmentId: this.profileValue.department == undefined ? '' : this.profileValue.department.objectId,
          roleId: this.profileValue.role == undefined ? '' : this.profileValue.role.objectId,
          reporterId: this.profileValue.reportingTo == undefined ? '' : this.profileValue.reportingTo.objectId,
          seatNo: this.profileValue.officialInfo.seatNo,
          reportingDate: this.profileValue.officialInfo.reportingDate,
          doj: this.profileValue.officialInfo.doj,
          officialEmail: this.profileValue.officialInfo.officialEmail,
          gitUserId: this.profileValue.officialInfo.gitUserId,
          billableStatus: this.profileValue.billableStatus,
          yearofExperiences: this.profileValue.officialInfo.experience.year == undefined ? 0 : this.profileValue.officialInfo.experience.year,
          months: this.profileValue.officialInfo.experience.month == undefined ? 0 : this.profileValue.officialInfo.experience.month,
          startTime: this.profileValue.officialInfo.startTime,
          employeeCode: results.get('esslEmployeeCode') ? results.get('esslEmployeeCode') : '',
          employeeId: results.get('esslEmployeeId') ? results.get('esslEmployeeId') : ''
        });
        this.oldvalue = JSON.parse(JSON.stringify(this.officialDetailsForm.value));
      }
    });
  }

  async getLocation() {
    let result = [];
    this.queryInterface.executeQuery(this.parseService, 'Location', [{ condition: 'equalTo', field: 'isActive', value: true }, { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
    { field: 'name', condition: 'descending' }]).then(results => {
      for (let i = 0; i < results.length; i++) {
        let jsonText = JSON.stringify(results[i]);
        let locationInfo = JSON.parse(jsonText);
        result.push({ id: locationInfo.objectId, name: locationInfo.name });
      }
      this.locationList = result;
    });
  }

  async getOrganisation() {
    let result = [];
    this.queryInterface.executeQuery(this.parseService, 'Organisation', [{ condition: 'equalTo', field: 'isActive', value: true }, { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
    { field: 'name', condition: 'descending' }]).then(results => {
      for (let i = 0; i < results.length; i++) {
        let jsonText = JSON.stringify(results[i]);
        let organisationInfo = JSON.parse(jsonText);
        result.push({
          id: organisationInfo.objectId,
          name: organisationInfo.name
        });
      }
      this.organisationLists = result;
    });
  }

  async getDepartment() {
    let result = [];
    this.queryInterface.executeQuery(this.parseService, 'TenantDepartment',
      [{ condition: 'equalTo', field: 'tenantId', value: this.tenantId }]).then(results => {
        if (results.length > 0) {
          for (let department of results) {
            this.departmentList.push({
              id: department.get('department').id,
              name: department.get('displayName'),
            });
          }
        }
        else {
          this.queryInterface.executeQuery(this.parseService, 'Department', [{ condition: 'equalTo', field: 'isActive', value: true },
          { field: 'name', condition: 'descending' }]).then(results => {
            for (let i = 0; i < results.length; i++) {
              let jsonText = JSON.stringify(results[i]);
              let departmentInfo = JSON.parse(jsonText);
              result.push({
                id: departmentInfo.objectId,
                name: departmentInfo.name
              });
            }
            this.departmentList = result;
          });
        }
      });
  }

  async getRole() {
    let result = [];
    this.queryInterface.queryRole(this.parseService).then(results => {
      for (let i = 0; i < results.length; i++) {
        let jsonText = JSON.stringify(results[i]);
        let roleInfo = JSON.parse(jsonText);
        if (roleInfo.displayName) {
          result.push({ id: roleInfo.role.objectId, name: roleInfo.displayName });
          this.roleList = result;
        }
        else {
          result.push({ id: roleInfo.objectId, name: roleInfo.name });
          this.roleList = result;
        }
      }
    });
  }

  async getReportingTo() {
    let reportingToEmployee = false;
    this.queryInterface.queryUserReporting(this.parseService, reportingToEmployee).then(results => {
      this.reportList = results;
    });

  }

  departmentChange(event) {
    let deptId = this.departmentList.filter(x => x.id == event.value);
    this.selectedDepartment = deptId[0].name;
  }

  async officialDetailsSave() {
    var profileValues = this.officialDetailsForm.value;

    let esslData = {
      employeeCode: profileValues.employeeCode ? profileValues.employeeCode : '',
      employeeId: profileValues.employeeId ? profileValues.employeeId : ''
    }
    let data = {
      officialInfo: {
        seatNo: profileValues.seatNo,
        reportingDate: profileValues.reportingDate,
        doj: profileValues.doj,
        officialEmail: profileValues.officialEmail,
        experience: {
          year: profileValues.yearofExperiences,
          month: profileValues.months
        },
        gitUserId: profileValues.gitUserId,
        startTime: profileValues.startTime,
      }
    }
    let emploeeSettings = [
      {
        moduleName: "Employees",
        All: false,
        Assigned: true,
        None: false,
      },
      {
        moduleName: "Projects",
        All: false,
        Assigned: true,
        None: false,
      }
    ]
    let adminSettings = [
      {
        moduleName: "Employees",
        All: true,
        Assigned: false,
        None: false,
      },
      {
        moduleName: "Projects",
        All: true,
        Assigned: false,
        None: false,
      }
    ]
    let queryInstance = this.parseService.instance.Object.extend('CustomRoleSettings');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('profile', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
    let result = await query.find();
    let roles = result[0];
    if (roles) {
      if (this.selectedDepartment == 'Management') {
        roles.set('customRoles', adminSettings);
      }
      else {
        roles.set('customRoles', emploeeSettings);
      }
      let res = await roles.save();
    }
    let activities = await this.activityCenterService.getActivity(this.oldvalue, profileValues, '');
    this.activityCenterService.createActivity(activities, this.hardCodedValues.profileView, this.objectId);

    this.profileInterface.updateProfileDetails(this.profileId, data, profileValues, this.locationList, this.organisationLists, this.departmentList, this.roleList, this.reportingtoList, esslData).then(async res => {
      this.toastr.success(this.toastMessage.Save);

      this.getOfficialDetails();
    });

  }

  @ViewChild("releasePop", { static: false }) releasePop: TemplateRef<any>;
  releasePopup() {
    this.getResignation();

    this.dialog.open(this.releasePop, {
      width: "300px"
    });
  }

  close() {
    this.router.navigate(['profile-view', { id: this.objectId }]);
    this.dialog.closeAll();
  }

  releaseEmployees() {
    if (this.resignationForm.value.releasedDate == undefined || this.resignationForm.value.releasedDate == '') {
      this.toastr.warning("Please enter the resignation details")
    }
    else {
      this.queryInterface.executeQuery(this.parseService, 'Profile', [{ condition: 'equalTo', field: 'objectId', value: this.objectId }]).then(result => {
        var results = result[0];
        let name = results.get('firstName') + ' ' + results.get('lastName');
        results.set('isActive', false);
        results.save().then(rest => {
          (rest[0]);
        })
        this.dialog.closeAll();
        this.toastr.success("Resources Released Successfully");

        let activityClass = this.parseService.instance.Object.extend("ActivityCenter");
        var activityDetails = new activityClass();
        activityDetails.set("moduleType", 'Profile-View');
        activityDetails.set("updatedBy", { __type: 'Pointer', className: 'Profile', objectId: this.currentUser.get('profile').id });
        activityDetails.set("message", ' Released employee ' + name);
        activityDetails.set('updatedId', this.objectId);
        activityDetails.save();
      });
    }
  }

  getResignation() {
    this.queryInterface.executeQuery(this.parseService, 'Profile', [{ condition: 'equalTo', field: 'objectId', value: this.objectId }]).then(result => {
      var results = result[0];
      let jsonText = JSON.stringify(results);
      let user = JSON.parse(jsonText);
      this.resignationForm.patchValue({
        resignationAppliedDate: user.resignationInfo.resignationAppliedDate,
        noticePeriod: user.resignationInfo.noticePeriod,
        resignationAcceptedDate: user.resignationInfo.resignationAcceptedDate,
        releasedDate: user.resignationInfo.releasedDate,
      });
    });
  }

  chosenYearHandler(normalizedYear: Moment): void {
    const ctrlValue = this.formDate.value;
    ctrlValue.year(normalizedYear.year());
    this.formDate.setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>): void {
    const ctrlValue = this.formDate.value;
    ctrlValue.month(normalizedMonth.month());
    this.formDate.setValue(ctrlValue);
    let date = new Date(this.formDate.value);
    let filterDate = date.getMonth() == new Date().getMonth() ? new Date() : new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.getResourceStatus(filterDate);
    datepicker.close();
  }

  async getResourceStatus(filterDate) {
    this.getHolidays(filterDate);
    let user = this.parseService.instance.Object.extend('ResourceStatus');
    let query = new this.parseService.instance.Query(user);
    query.equalTo('user', { __type: 'Pointer', className: '_User', objectId: this.selectedUserId });
    let dateDifferent = this.dateService.startEndDateByMonth(filterDate ? filterDate : new Date());
    query.greaterThan('createdAt', dateDifferent[0]);
    query.lessThan('createdAt', dateDifferent[1]);
    query.limit(10000);
    let result = await query.find();
    this.dedicatedBillable = (result.filter(x => x.get('resourceStatus') == 'Dedicated Billable')).length;
    this.fixedBillable = (result.filter(x => x.get('resourceStatus') == 'Fixed Billable')).length;
    this.nonBillable = (result.filter(x => x.get('resourceStatus') == 'Non-Billable')).length;
  }

  async getHolidays(filterDate) {
    this.nonWorkingDays = [];
    var selectedDate = filterDate ? filterDate : new Date();
    var getTot = this.daysInMonth(selectedDate.getMonth() + 1, selectedDate.getFullYear());
    var currentMonth = new Array();
    for (let i = 1; i <= getTot; i++) {
      let newDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), i)
      currentMonth.push(newDate);
    }

    for (let j = 0; j < currentMonth.length; j++) {
      let datesAll = new Date(selectedDate.getFullYear(), currentMonth[j].getMonth(), currentMonth[j].getDate());
      let dayOfWeek = datesAll.getDay();
      let dateOfMonth = datesAll.getDate();
      let isEvenWeek = Math.ceil(dateOfMonth / 7);
      let epochOddDates = datesAll.getTime();
      if (dayOfWeek == 0) {
        if (this.nonWorkingDays.indexOf(epochOddDates) === -1) {
          this.nonWorkingDays.push(new Date(epochOddDates));
        }
      } if (dayOfWeek == 6 && isEvenWeek % 2 != 0) {
        if (this.nonWorkingDays.indexOf(epochOddDates) === -1) {
          this.nonWorkingDays.push(new Date(epochOddDates));
        }
      }
    }

    const currentYear = selectedDate.getFullYear();
    const holidaysInstance = this.parseService.instance.Object.extend('Holidays');
    const holidayQuery = new this.parseService.instance.Query(holidaysInstance);
    holidayQuery.equalTo('year', currentYear);
    const leaveResults = await holidayQuery.find();
    if (leaveResults.length > 0) {
      let holidayList = leaveResults[0].get('dateList') == undefined ? {} : leaveResults[0].get('dateList');
      const allowed = [];
      allowed.push(String(selectedDate.getMonth()));
      const filtered = Object.keys(holidayList)
        .filter(key => allowed.includes(key))
        .reduce((obj, key) => {
          obj[key] = holidayList[key];
          return obj;
        }, {});
      let data = filtered[Object.keys(filtered)[0]];
      for (let k = 0; k < data.length; k++) {
        let newDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), data[k]);
        this.nonWorkingDays.push((newDate));
      }
    }

    this.workingDays = currentMonth.length - this.nonWorkingDays.length;
  }

  removeDuplicates(arr1, arr2) {
    return [...new Set(arr1.concat(arr2).filter(e => !(arr2.includes(e) && arr1.includes(e))))];
  }

  daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
  }


}